export const AmplifyConfig = {
  aws_appsync_graphqlEndpoint: `${process.env.REACT_APP_GRAPH_QL_API}/graphql`,
  aws_appsync_authenticationType: 'AWS_LAMBDA',
};
